import angular from 'angular';
import compareProductsComponent from './compare-products.component';
import CompareProductsService from './compare-products.service';
import compareProductsConfig from './compare-products.config';

let compareProductsModule = angular.module('app.compareProducts',[])
  .component('compareProducts', compareProductsComponent)
  .service('CompareProductsService', CompareProductsService)
  .config(compareProductsConfig);
export default compareProductsModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/compare-products/compare-products.js
 **/